import { createSearchParams } from 'react-router-dom';
import { path, createCachedSelector, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { ISearchParamName } from '../router.interface';
import { locationSelector } from './location.selector';

export const queryParamsSelector = createCachedSelector(
  [
    path(locationSelector).search(),
    prop<ISearchParamName>().name(),
  ],
  (search, name) => {
    const params = createSearchParams(search);
    return params.getAll(name);
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<ISearchParamName>().name(),
});
